"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quote = function Quote() {
  return _react2.default.createElement(
    "g",
    { id: "quote" },
    _react2.default.createElement("path", { d: "M316.028 10.665c21.931 0 39.775 18.718 39.775 41.724v0 25.914c0 9.285-7.525 16.811-16.811 16.811s-16.811-7.525-16.811-16.811v0-25.914c0-3.559-2.761-6.455-6.154-6.455v0h-276.261c-3.385 0-6.146 2.895-6.146 6.455v0 343.22c0 3.552 2.761 6.455 6.146 6.455v0h276.261c3.394 0 6.154-2.905 6.154-6.455v0-22.402c0-9.285 7.525-16.811 16.811-16.811s16.811 7.525 16.811 16.811v0 22.402c0 23.005-17.845 41.724-39.775 41.724v0h-276.261c-21.931 0-39.767-18.718-39.767-41.724v0-343.22c0-23.005 17.836-41.724 39.767-41.724v0zM373.567 105.291c4.365-0.837 9.005 0.099 12.694 2.566v0l54.276 36.292c7.745 5.177 9.796 15.634 4.572 23.308v0l-108.706 155.985c-1.491 2.177-3.557 4.035-5.946 5.307v0l-62.253 33.39c-2.482 1.325-5.271 2.025-8.060 2.025-3.405 0-6.685-1.005-9.496-2.894-5.233-3.495-8.053-9.555-7.337-15.8v0l7.991-69.688c0.315-2.681 1.284-5.277 2.813-7.507v0l108.685-155.962c2.444-3.595 6.393-6.184 10.773-7.021zM381.282 145.025l-96.79 138.685-3.857 33.581 30.105-16.135 96.735-138.615-26.194-17.514z" }),
    _react2.default.createElement("path", { d: "M81.28 117.334h178.774c9.544 0 17.28 7.736 17.28 17.28s-7.736 17.28-17.28 17.28h-178.774c-9.544 0-17.28-7.736-17.28-17.28s7.736-17.28 17.28-17.28z" }),
    _react2.default.createElement("path", { d: "M81.28 181.334h136.106c9.544 0 17.28 7.736 17.28 17.28s-7.736 17.28-17.28 17.28h-136.106c-9.544 0-17.28-7.736-17.28-17.28s7.736-17.28 17.28-17.28z" }),
    _react2.default.createElement("path", { d: "M81.28 245.334h93.44c9.544 0 17.28 7.736 17.28 17.28s-7.736 17.28-17.28 17.28h-93.44c-9.544 0-17.28-7.736-17.28-17.28s7.736-17.28 17.28-17.28z" }),
    _react2.default.createElement("path", { d: "M81.28 309.334h93.44c9.544 0 17.28 7.736 17.28 17.28s-7.736 17.28-17.28 17.28h-93.44c-9.544 0-17.28-7.736-17.28-17.28s7.736-17.28 17.28-17.28z" })
  );
};

exports.default = Quote;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Quote.js
// module id = 2978
// module chunks = 4